import { Box, Button, Switch, DialogBody, DialogClose, DialogHeader, openModal } from '@ff-it/ui';
import { ReactElement, useState } from 'react';
import { Summary } from './Summary';
import { PlanRow } from 'modules/campaign/row';

type SummaryDialogProps = {
  rows: PlanRow[];
};

function SummaryDialog({ rows }: SummaryDialogProps): ReactElement {
  const [showMonths, setShowMonths] = useState<boolean>(false);

  return (
    <>
      <DialogHeader title="Plan summary">
        <Box ml="3" display="flex" alignItems="center">
          <Switch checked={showMonths} onChange={(e) => setShowMonths(e.target.checked)} id="expand-months" size="sm" />
          <Box as="label" htmlFor="expand-months" mb="0" ml="2" fontSize="sm" userSelect="none">
            Expand months
          </Box>
        </Box>
        <DialogClose className="ml-auto" size="sm" />
      </DialogHeader>
      <DialogBody>
        <Summary showMonths={showMonths} rows={rows} />
      </DialogBody>
    </>
  );
}

export function SummaryButton({ rows }: SummaryDialogProps): ReactElement {
  return (
    <Button
      variant="secondary"
      size="sm"
      data-testid="toggle-summary"
      onClick={() => openModal(() => <SummaryDialog rows={rows} />, { className: 'right', testId: 'summary' })}
      icon="list-tree"
    >
      Summary
    </Button>
  );
}
